"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _scriptHelper = require("./../../helpers/script-helper");

var _urlHelper = require("./../../helpers/url-helper");

/**
 * Appmachine insights logger, includes javascript from am insights, and starts logging when the insight ID is known
 * these methodes will be called by the analytics service!
 *
 * @class AppmachineInsightsLogger
 */
var AppmachineInsightsLogger = /*#__PURE__*/function () {
  function AppmachineInsightsLogger() {
    (0, _classCallCheck2["default"])(this, AppmachineInsightsLogger);
  }

  (0, _createClass2["default"])(AppmachineInsightsLogger, [{
    key: "init",
    value:
    /**
     * called by Analytics service when its ready to send analytics
     *
     *
     * @memberOf AppmachineInsightsLogger
     */
    function init() {// this is not impelmented, we need a insight id before we can include the script!
    }
  }, {
    key: "includeJs",
    value: function includeJs(insightsId) {
      var _this = this;

      // can call this 100 of times. it will check if the id: 'am-analtics-tracker' exists in the dom
      (0, _scriptHelper.IncludeJavaScript)((0, _urlHelper.getUrl)(_urlHelper.siteNames.SDK_ANALYTICS_TRACKER), 'am-analytics-tracker', function () {
        // todo setup the needed info
        window.AMAnalytics && window.AMAnalytics.initialize({
          insightsId: insightsId // todo copy existing session from published site
          // identity: {
          //   userId: '',
          //   sessionId: '',
          //   userDateTime: 0
          // }

        });
        _this.isInitialized = true;
      });
    }
  }, {
    key: "setInsightId",
    value: function setInsightId(insightId) {
      if (!this.isInitialized) {
        this.isInitialized = true;
        this.includeJs(insightId);
      }
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "login",
    value: function login() {}
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "logout",
    value: function logout() {}
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackPageView",
    value: function trackPageView(path) {
      if (this.isInitialized) {
        window.AMAnalytics.pageView(path);
      }
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackEvent",
    value: function trackEvent(action, obj) {
      if (this.isInitialized) {
        window.AMAnalytics.event(action);
      }
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackEcommercePurchase",
    value: function trackEcommercePurchase(orderId, totalPriceExTax, totalTax, status, products) {
      if (this.isInitialized) {
        window.AMAnalytics.event('checkout', 'completed', totalPriceExTax + totalTax);
      }
    }
  }]);
  return AppmachineInsightsLogger;
}();

var _default = new AppmachineInsightsLogger();

exports["default"] = _default;